import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Button } from '@uswitch/spark.button';
import PropTypes from 'prop-types';
import React from 'react';
import { useDropdownContext } from './context';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var defaultProps = {
  role: 'menubutton',
  'aria-haspopup': 'menu',
  'aria-controls': 'menu',
  asText: true
};
export var DropdownButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var CustomButton = _ref.as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "children"]);

  var _useDropdownContext = useDropdownContext(),
      hidden = _useDropdownContext.hidden,
      handleClick = _useDropdownContext.handleClick,
      handleKeyUp = _useDropdownContext.handleKeyUp,
      selected = _useDropdownContext.selected;

  var allProps = _objectSpread(_objectSpread({
    onClick: handleClick,
    onKeyUp: handleKeyUp
  }, defaultProps), props);

  return CustomButton !== null ? _jsx(CustomButton, _objectSpread(_objectSpread({
    value: selected.value,
    "aria-expanded": !hidden
  }, allProps), {}, {
    ref: ref
  })) : _jsx(Button, _objectSpread(_objectSpread({}, allProps), {}, {
    ref: ref,
    children: children
  }));
});
DropdownButton.propTypes = {
  /**
   * Custom component to use as dropdown button toggle
   */
  as: PropTypes.elementType
};
DropdownButton.defaultProps = {
  as: null
};
DropdownButton.displayName = 'DropdownButton';